import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UploadSelfieRequest {
  image: File
  uuid: string
}

export interface UploadIdentificationResponse {
  data: {
    imageUrl: string
  }
  meta: {
    message: string
    errors: string[]
  }
}

export function uploadIdentificationAction(
  data: UploadSelfieRequest
): Promise<ApiResponse<UploadIdentificationResponse>> {
  const formData = new FormData()
  formData.append('image', data.image)

  return api.post<ApiResponse<UploadIdentificationResponse>>(`/users/${data.uuid}/upload-identification`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
